<template lang="pug">
  .flooring-related-products
    .product(v-for="buyRequest in buyRequests")
      rhpa-child(:buy-request="buyRequest" :layout="'accessory'" :groupMeta="groupMeta" :showBadges="false")
</template>
<script>
import { defineAsyncComponent } from 'vue'

export default {
  name       : 'FlooringRelatedProducts',
  components : {
    RhpaChild: defineAsyncComponent(() => import(/* webpackChunkName: "rhp-flooring" */'@/js/components/rhpa/rhpa-child.vue')),
  },
  props: {
    groupMeta: {
      type     : Object,
      required : true,
    },
    buyRequests: {
      type     : Array,
      required : true,
    },
  },
}
</script>
<style lang="scss" scoped>
.flooring-related-products {
  margin: $size-s 0;
  .product {
    display: flex;
    justify-content: space-between;
    margin-bottom: $size-s;

    .description {
      display: flex;
      align-items: center;

      span {
        flex: 1 0;
      }

      .product-image {
        width: 60px;
        height: 60px;
        margin-right: $size-xs;
      }
    }
    .price-quantity {
      display: flex;
      align-items: center;
      .quantity {
        width: 60px;
      }
    }
  }
}
</style>
